import React from 'react'
import { Link } from 'react-router-dom'

function MobileAppPortal() {
  return (
    <>
      <section className="about-sec-app pad-tb pt60 dark-bg2">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="common-heading text-l">
                <h2 className="mb30"><span className="text-second text-bold">Why N D Techland</span>
                </h2>
                <p>Choosing the right technology partner is critical to achieving successful digital transformation. N D Techland Pvt. Ltd. stands out as a reliable and future-focused IT solutions provider committed to delivering secure, scalable, and impactful digital systems for government bodies, institutions, and enterprises.</p>
                <p className="mt10"><span className=" text-bold">Proven Domain Expertise </span>

                   with extensive experience in e-Governance and enterprise IT solutions, we understand complex operational environments and deliver systems that improve efficiency, transparency, and service delivery.</p>
                <p className="mt10"><span className=" text-bold">Scalable & Future-Ready Technology </span>

                  our platforms are built using modern technologies that support scalability, integration, and adaptability to future needs.</p>
                  <p className="mt10"><span className=" text-bold">Government & Enterprise Experience </span>

                 our solutions are designed to meet the standards, compliance requirements, and operational needs of government departments and large organizations.</p>
              </div>
              <div className="cta-card mt40">
                <Link to="/contactus" className="btn-outline lnk">Request A Quote<i
                  className="fas fa-chevron-right fa-icon"></i>
                  <span className="circle"></span></Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="funfact">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl1 h-100 w-100 text-center p-3">
                      <img src="images/icons/startup.svg" alt="Years Experience" />
                    
                      <p>14+ Years Experience</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl2 h-100 w-100 text-center p-3">
                      <img src="images/icons/team.svg" alt="Talented Squad" />
                   
                      <p>Skilled & Dedicated Team</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl3 h-100 w-100 text-center p-3">
                      <img src="images/icons/mobile.svg" alt="Apps Developed" />
                     
                      <p>End-to-End Solution Provider
</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl4 h-100 w-100 text-center p-3">
                      <img src="images/icons/computers.svg" alt="Projects Delivered" />
                      
                      <p>100+ Projects Delivered</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl5 h-100 w-100 text-center p-3">
                      <img src="images/icons/world.svg" alt="Cities Served" />
                      
                      <p>Transparent & Timely Delivery</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl1 h-100 w-100 text-center p-3">
                      <img src="images/icons/deal.svg" alt="Client Satisfaction" />
                    
                      <p>Client-Centric Approach</p>
                    </div>
                  </div>
                   <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl4 h-100 w-100 text-center p-3">
                      <img src="images/icons/world.svg" alt="Cities Served" />
                      
                      <p>Focus on Security & Reliability</p>
                    </div>
                  </div>
                   <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl5 h-100 w-100 text-center p-3">
                      <img src="images/icons/world.svg" alt="Cities Served" />
                      
                      <p>Long-Term  Maintenance</p>
                    </div>
                  </div>
                   <div className="col-lg-4 col-md-6 col-sm-12 col-6 d-flex">
                    <div className="funfct srcl4 h-100 w-100 text-center p-3">
                      <img src="images/icons/world.svg" alt="Cities Served" />
                      
                      <p>Digital Transformation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default MobileAppPortal